import React, { Component } from 'react';
import { AgGridReact } from 'ag-grid-react';
import SearchMenu from './searchMenu';
import { getUserDetails } from '../../../../services/common/util';
import { createAudit } from '../../../../services/clinicPortalServices/auditService';
import { auditEnums, serviceConstants } from '../../../../services/common/constants';
import { ThemeContext } from '../../../../theme/ThemeProvider';
import { fetchQcResults } from '../../../../services/clinicPortalServices/qcResultService';
import { fetchQcRanges } from '../../../../services/clinicPortalServices/qcRangeService';
import moment from 'moment';
import { colorSchemeDark, colorSchemeLight, themeQuartz } from 'ag-grid-community';

const themeLight = themeQuartz.withPart(colorSchemeLight);
const themeDark = themeQuartz.withPart(colorSchemeDark);

class QcResultGrid extends Component {
    constructor(props) {
        super(props);

        this.state = {
            quickFilterText: '',
            columnDefs: [
                {
                    headerName: 'QC Run',
                    minWidth: 150,
                    resizable: true,
                    field: 'qc_run_index'
                },
                {
                    headerName: 'Analyte',
                    minWidth: 250,
                    resizable: true,
                    valueGetter: (params) => {
                        return params.data.analyte_id ? params.data.analyte_id.name : '';
                    }
                },
                {
                    headerName: 'Control Type',
                    minWidth: 150,
                    resizable: true,
                    valueGetter: (params) => {
                        if (params.data.qc_sample_id) {
                            return params.data.qc_sample_id.controlType;
                        }
                    }
                },
                {
                    headerName: 'Target Value',
                    minWidth: 150,
                    resizable: true,
                    field: 'targetValue'
                },
                {
                    headerName: 'Value',
                    minWidth: 150,
                    resizable: true,
                    field: 'value'
                },
                {
                    headerName: 'Unit',
                    minWidth: 150,
                    resizable: true,
                    valueGetter: (params) => {
                        return params.data.analyte_id ? params.data.analyte_id.units : '';
                    }
                },
                {
                    headerName: 'Passed?',
                    minWidth: 150,
                    resizable: true,
                    valueGetter: (params) => {
                        if (params.data.targetValue) {
                            return Math.abs(params.data.value - params.data.targetValue) <=
                                Number(params.data.targetValue) * 0.2
                                ? 'Yes'
                                : 'No';
                        }
                    }
                },
                {
                    headerName: 'Within 10% Target?',
                    minWidth: 150,
                    resizable: true,
                    valueGetter: (params) => {
                        if (params.data.targetValue) {
                            return Math.abs(params.data.value - params.data.targetValue) <=
                                Number(params.data.targetValue) * 0.1
                                ? 'Yes'
                                : 'No';
                        }
                    }
                },
                {
                    headerName: 'Within 20% Target?',
                    minWidth: 150,
                    resizable: true,
                    valueGetter: (params) => {
                        if (params.data.targetValue) {
                            return Math.abs(params.data.value - params.data.targetValue) <=
                                Number(params.data.targetValue) * 0.2
                                ? 'Yes'
                                : 'No';
                        }
                    }
                },
                {
                    headerName: 'State',
                    minWidth: 150,
                    resizable: true,
                    field: 'state'
                },
                {
                    headerName: 'QC Group Valid?',
                    minWidth: 150,
                    resizable: true,
                    field: 'qc_group_valid'
                },
                {
                    headerName: 'QC Grouping',
                    minWidth: 150,
                    resizable: true,
                    field: 'qc_grouping',
                    valueGetter: (params) => {
                        return params.data.analyte_id ? 'for ' + params.data.analyte_id.name : '';
                    }
                },
                {
                    headerName: 'Run Date/Time',
                    minWidth: 150,
                    resizable: true,
                    valueGetter: (params) => {
                        if (params.data.run_date) {
                            return moment(params.data.run_date, 'YYYYMMDDHHmmss').format('MM/DD/YYYY hh:mm A');
                        }
                    }
                },
                {
                    headerName: 'Instrument',
                    minWidth: 150,
                    resizable: true,
                    valueGetter: (params) => {
                        if (params.data.instrument_id) {
                            return params.data.instrument_id.name;
                        }
                    }
                },
                {
                    headerName: 'QC Sample',
                    minWidth: 150,
                    resizable: true,
                    valueGetter: (params) => {
                        if (params.data.qc_sample_id) {
                            return params.data.qc_sample_id.name;
                        }
                    }
                },
                {
                    headerName: 'Lot Number',
                    minWidth: 150,
                    resizable: true,
                    valueGetter: (params) => {
                        if (params.data.qc_sample_id) {
                            return params.data.qc_sample_id.lotNumber;
                        }
                    }
                },
                {
                    headerName: 'Lot Expiration Date',
                    minWidth: 150,
                    resizable: true,
                    valueGetter: (params) => {
                        if (params.data.qc_sample_id && params.data.qc_sample_id.lotExpirationDate) {
                            return moment(params.data.qc_sample_id.lotExpirationDate, 'YYYYMMDD').format('MM/DD/YYYY');
                        }
                    }
                },
                {
                    headerName: 'Creation Date',
                    minWidth: 150,
                    resizable: true,
                    valueGetter: (params) => {
                        return moment
                            .tz(params.data.createdAt, serviceConstants.SYSTEM_TIME_ZONE)
                            .format('MM/DD/YYYY hh:mm:ss A');
                    }
                },
                {
                    headerName: 'Created By',
                    minWidth: 150,
                    resizable: true,
                    field: 'created_by'
                }
            ],
            components: {},
            defaultColDef: {
                flex: 1,
                filter: true,
                sortable: true
            },
            rowData: [],
            context: { componentParent: this },
            qcRanges: []
        };
    }

    onGridReady = (params) => {
        this.gridApi = params.api;

        this.loadGridData();
    };

    loadGridData = () => {
        fetchQcRanges().then((res) => {
            this.setState({ qcRanges: res.data }, () => {
                fetchQcResults().then((res) => {
                    res.data.map((qcResultItem) => {
                        let matchingRange = this.state.qcRanges.find(
                            (item) =>
                                item.analyteId._id === qcResultItem.analyte_id._id &&
                                item.controlType === qcResultItem.qc_sample_id.controlType
                        );
                        qcResultItem.targetValue = matchingRange ? matchingRange.targetValue : null;
                    });
                    this.setState({ rowData: res.data });
                });
            });
        });
    };

    onFilterTextChange = (e) => {
        this.setState({ quickFilterText: e.target.value });
    };

    clearFilter = () => {
        this.gridApi.setFilterModel(null);
        this.setState({ quickFilterText: '' });
        document.getElementById('reset-form').value = '';
    };

    onBtnExport = () => {
        this.gridApi.exportDataAsExcel({
            fileName: 'QC_Result_Grid_' + moment().format('YYYY_MM_DD_HH_mm_ss') + '.xlsx',
            sheetName: 'QC Results'
        });
        const userData = JSON.parse(getUserDetails());
        const auditData = {
            identifier: auditEnums.IDENTIFIERS.ExportRecord,
            event_type: auditEnums.EVENTTYPES.QcResultGridExported,
            user_id: userData._id,
            user_name: userData.user_name + ' (' + userData.role + ')',
            update_string: auditEnums.EVENTTYPES.QcResultGridExported
        };
        createAudit(auditData);
    };

    render() {
        let columnDefs = this.state.columnDefs;
        return (
            <div className="clinic-contain">
                <SearchMenu
                    onFilterTextChange={this.onFilterTextChange}
                    clearFilter={this.clearFilter}
                    onBtnExport={this.onBtnExport}
                    context={this.state.context}
                />
                <div
                    style={{
                        width: '100%',
                        height: 'calc(100vh - 250px)',
                        padding: '15px'
                    }}
                >
                    <ThemeContext.Consumer>
                        {({ themeName }) => (
                            <div
                                id="myGrid"
                                style={{
                                    height: '100%',
                                    width: '100%'
                                }}
                            >
                                <AgGridReact
                                    columnDefs={columnDefs}
                                    defaultColDef={this.state.defaultColDef}
                                    masterDetail={true}
                                    onGridReady={this.onGridReady}
                                    rowData={this.state.rowData}
                                    pagination={true}
                                    paginationAutoPageSize={true}
                                    components={this.state.components}
                                    context={this.state.context}
                                    theme={themeName === 'Light' ? themeLight : themeDark}
                                    quickFilterText={this.state.quickFilterText}
                                />
                            </div>
                        )}
                    </ThemeContext.Consumer>
                </div>
            </div>
        );
    }
}

export default QcResultGrid;
